export const fi = {
  'app.title': 'Laskurit',
  'meta.title': 'Laskurit',
  'meta.description': 'Kätsyt laskurit, myös kännykkään!',

  'nav.all': 'Kaikki',
  'nav.time': 'Aikaleimat',
  'nav.numbers': 'Numerot ja merkit',
  'nav.identifiers': 'Tunnisteet',
  'nav.colors': 'Värit',
  'nav.bytesizes': 'Tavukoot',
  'nav.links': 'Linkit',
  'nav.textConversions': 'Tekstimuunnokset',
  'nav.cryptography': 'Kryptografia',
  'nav.pixeldensity': 'Pikselitiheys',
  'nav.worktime': 'Työaika',

  'theme.system': 'Järjestelmän teema',
  'theme.light': 'Vaalea teema',
  'theme.dark': 'Tumma teema',

  'lang.toggleTooltip': 'Vaihda englanniksi',

  'page.numbers.title': 'Numerot',
  'page.numbers.binary': 'Binääri',
  'page.numbers.octal': 'Oktaali',
  'page.numbers.decimal': 'Desimaali',
  'page.numbers.hex': 'Heksa',
  'page.numbers.char': 'Merkki',
  'page.numbers.unicode': 'Unicode',
  'page.numbers.html': 'HTML-entiteetti',

  'page.time.title': 'Aikaleimat',
  'page.time.label.date': 'Päivä',
  'page.time.label.time': 'Kellonaika',
  'page.time.label.week': 'Viikko',
  'page.time.label.nameDay': 'Nimipäivä',
  'page.time.label.nameDaySearch': 'Etsi nimipäivä',
  'page.time.label.javaTime': 'Java/JS time',
  'page.time.label.unixTime': 'Unixtime',
  'page.time.label.iso8601': 'ISO (selain)',
  'page.time.label.iso8601utc': 'ISO (UTC)',
  'page.time.weekDay.mon': 'ma',
  'page.time.weekDay.tue': 'ti',
  'page.time.weekDay.wed': 'ke',
  'page.time.weekDay.thu': 'to',
  'page.time.weekDay.fri': 'pe',
  'page.time.weekDay.sat': 'la',
  'page.time.weekDay.sun': 'su',

  'page.identifiers.title': 'Tunnisteet',
  'page.identifiers.hetu': 'Henkilötunnus',
  'page.identifiers.bankReference': 'Viitenumero',
  'page.identifiers.companyId': 'Y-tunnus',
  'page.identifiers.luhn': 'Luhn modulo 10',
  'page.identifiers.randomString': 'Satunnaisjono',

  'page.colors.title': 'Väri',
  'page.colors.hex.subtitle': 'Heksakoodi',
  'page.colors.rgb.subtitle': 'RGB-arvo',
  'page.colors.hex.label': 'Heksa',
  'page.colors.rgb.label': 'RGB-arvo',
  'page.colors.addColor': 'Tallenna väri',
  'page.colors.addColorPrompt': 'Anna värin nimi',
  'page.colors.hsl.h': 'H: Sävy',
  'page.colors.hsl.s': 'S: Kylläisyys',
  'page.colors.hsl.l': 'L: Vaaleus',

  'page.bytesizes.title': 'Tavukoot',
  'page.bytesizes.byte': 'Tavua',
  'page.bytesizes.kibi': 'Kibitavua',
  'page.bytesizes.mebi': 'Mebitavua',
  'page.bytesizes.gibi': 'Gibitavua',
  'page.bytesizes.tebi': 'Tebitavua',
  'page.bytesizes.kilo': 'Kilotavua',
  'page.bytesizes.mega': 'Megatavua',
  'page.bytesizes.giga': 'Gigatavua',
  'page.bytesizes.tera': 'Teratavua',

  'page.pixeldensity.title': 'Pikselitiheys',
  'page.pixeldensity.width': 'Leveys',
  'page.pixeldensity.height': 'Korkeus',
  'page.pixeldensity.widthPlaceholder': 'leveys',
  'page.pixeldensity.heightPlaceholder': 'korkeus',

  'page.worktime.title': 'Työaika',
  'page.worktime.subtitle': 'Päivän työajan laskuri',
  'page.worktime.start': 'Alku',
  'page.worktime.entries': 'Kirjaukset',
  'page.worktime.end': 'Loppu',
  'page.worktime.now': 'Nyt',
  'page.worktime.setNow': 'Aseta nykyinen kellonaika',
  'page.worktime.clockIn': 'Aloita',
  'page.worktime.pause': 'Tauko',
  'page.worktime.resume': 'Jatka',
  'page.worktime.addRow': 'Lisää rivi',
  'page.worktime.removeRow': 'Poista rivi',
  'page.worktime.clear': 'Tyhjennä',
  'page.worktime.subtractLunch': 'Lounas',
  'page.worktime.subtractCommute': 'Työmatka',
  'page.worktime.minutes': 'min',
  'page.worktime.target': 'Tavoite',
  'page.worktime.hours': 'h',
  'page.worktime.worked': 'Työaika',
  'page.worktime.away': 'Poissa',
  'page.worktime.remaining': 'Jäljellä',
  'page.worktime.leaveAt': 'Lähtöaika',
  'page.worktime.noRows': 'Ei kirjauksia. Paina Aloita, kun aloitat työt.',
  'page.worktime.error.endBeforeStart': 'Loppuaika on ennen alkuaikaa',
  'page.worktime.error.startInFuture': 'Alkuaika on tulevaisuudessa',
  'page.worktime.error.overlap': 'Rivi menee edellisen rivin päälle',

  'page.links.title': 'Linkit',
  'page.links.subtitle': 'Kerää linkkejä muistiin',
  'page.links.label': 'Linkki',

  'page.cryptography.title': 'Kryptografia',
  'page.cryptography.input': 'Syöte',

  'page.pipeline.title': 'Tekstimuunnokset',
  'page.pipeline.subtitle': 'Dataputki',
  'page.pipeline.processing': 'Käsitellään…',
  'pipeline.input.label': 'Syöte',
  'pipeline.input.clear': 'Tyhjennä',
  'pipeline.input.placeholder': 'Kirjoita tai liitä tekstiä, tai pudota tiedosto…',
  'pipeline.input.dropHere': 'Pudota tiedosto tähän',
  'pipeline.input.chooseFile': 'Valitse tiedosto',
  'pipeline.input.fetch': 'Hae',
  'pipeline.input.fetchFailed': 'Haku epäonnistui (CORS?)',
  'pipeline.input.chars': 'merkkiä',
  'pipeline.input.mode.text': 'Teksti / tiedosto',
  'pipeline.input.mode.randomString': 'Satunnainen merkkijono',
  'pipeline.input.mode.randomBytes': 'Satunnaiset tavut',
  'pipeline.input.length': 'Pituus',
  'pipeline.input.regenerate': 'Luo uusi',
  'pipeline.input.randomBytesInfo': 'Satunnaista dataa',
  'pipeline.output.result': 'Tulos',
  'pipeline.output.download': 'Lataa',
  'pipeline.output.bytes': 'tavua',
  'pipeline.output.chars': 'merkkiä',
  'pipeline.step.remove': 'Poista',
  'pipeline.addOperation': 'Lisää operaatio',
  'pipeline.addPipeline': 'Lisää dataputki',
  'pipeline.removePipeline': 'Poista dataputki',
  'pipeline.defaultTitle': 'Dataputki',
  'pipeline.renameTitle': 'Nimeä dataputki',
  'pipeline.reset': 'Nollaa',
  'pipeline.saveSetup': 'Tallenna putkisto',
  'pipeline.saveSetupPrompt': 'Anna asetelmalle nimi',
  'pipeline.loadSetup': 'Lataa asetelma',
  'pipeline.render.download': 'Lataa',
  'pipeline.render.unknownImage': 'Tuntematon kuvaformaatti',
  'pipeline.render.notSvg': 'Data ei ole SVG-muodossa',

  'component.subtitlePlaceholder': 'Valitse arvo',
  'component.copyToClipboard': 'Kopioi leikepöydälle',
  'component.copyHexToClipboard': 'Kopioi hex-merkkijono leikepöydälle',
  'component.lastValuePlaceholder': 'Viimeisin arvo',
  'component.generateNew': 'Luo uusi',
  'component.nameDaySearchPlaceholder': 'Etsi nimipäivä',
  'component.checkUuid': 'Tarkista UUID',
  'component.uuidTimestampMs': 'Aikaleima (ms)',
  'component.uuidTime': 'Purettu aika',
} as const;

export type TranslationKey = keyof typeof fi;
